<ppl-popup-dialog [isVisible]="visible" (isVisibleChange)="onVisibleChange($event)" [title]="title"
    [isOkText]="okText" (confirm)="onConfirm()" (cancel)="onVisibleChange(false)" [showButtons]="true"
    [showOkButton]="false" [size]="'medium'" [position]="'center'">
    <form nz-form [formGroup]="form">
        <p>{{ message }}</p>
        <nz-form-item>
            <nz-form-control>
                <label for="correctionNotes" class="field-header">Notes <span class="error-message1">*</span></label>
                <nz-textarea-count [nzMaxCharacterCount]="NOTES_MAX_LENGTH">
                    <textarea rows="3" nz-input id="correctionNotes" formControlName="notes"
                        [placeholder]="placeholder" [maxlength]="NOTES_MAX_LENGTH"
                        [nzStatus]="form.get('notes')?.invalid && form.get('notes')?.touched ? 'error' : ''"></textarea>
                </nz-textarea-count>
                @if (form.get('notes')?.invalid && form.get('notes')?.touched) {
                <div class="error-message">Please enter notes.</div>
                }
            </nz-form-control>
        </nz-form-item>
    </form>
</ppl-popup-dialog>
